import { render } from "./PWAComponent.vue?vue&type=template&id=d3d5ec2e"
import script from "./PWAComponent.vue?vue&type=script&lang=js"
export * from "./PWAComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/pwa/PWAComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3d5ec2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3d5ec2e', __exports__)) {
    api.reload('d3d5ec2e', __exports__)
  }
  
  module.hot.accept("./PWAComponent.vue?vue&type=template&id=d3d5ec2e", () => {
    api.rerender('d3d5ec2e', render)
  })

}


export default __exports__